/* Kurello — collection page: sorting, filter drawer, "load more" */
(() => {
  function init(section) {
    if (section.dataset.kReady) return;
    section.dataset.kReady = 'true';

    // Model chips: keep the active one in view, allow mouse drag-to-scroll
    const chips = section.querySelector('.k-chips--scroll');
    if (chips) {
      const active = chips.querySelector('.is-active');
      if (active && active.parentElement.previousElementSibling) {
        chips.scrollLeft = active.offsetLeft - chips.clientWidth / 2 + active.offsetWidth / 2;
      }
      let startX = 0;
      let startScroll = 0;
      let dragged = false;
      chips.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        startX = e.clientX;
        startScroll = chips.scrollLeft;
        dragged = false;
        const move = (ev) => {
          const dx = ev.clientX - startX;
          if (Math.abs(dx) > 4) dragged = true;
          chips.scrollLeft = startScroll - dx;
        };
        const up = () => {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
      });
      // A drag should not count as a click on the chip under the cursor
      chips.addEventListener('click', (e) => {
        if (dragged) {
          e.preventDefault();
          dragged = false;
        }
      }, true);
      chips.addEventListener('dragstart', (e) => e.preventDefault());
    }

    // Sorting keeps active filters, resets pagination
    const sort = section.querySelector('[data-k-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Filter drawer
    const drawer = section.querySelector('[data-k-filters]');
    if (drawer) {
      const open = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('k-lock');
        const first = drawer.querySelector('button, a, input, summary');
        if (first) setTimeout(() => first.focus(), 50);
      };
      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('k-lock');
      };
      section.querySelectorAll('[data-k-filter-open]').forEach((b) => b.addEventListener('click', open));
      drawer.querySelectorAll('[data-k-filter-close]').forEach((b) => b.addEventListener('click', close));
      drawer.addEventListener('keydown', (e) => e.key === 'Escape' && close());
    }

    // Load more: fetch the next page of this section and append its cards
    const grid = section.querySelector('[data-k-grid]');
    section.addEventListener('click', async (e) => {
      const more = e.target.closest('[data-k-more]');
      if (!more || !grid) return;
      e.preventDefault();
      more.classList.add('is-loading');
      try {
        const url = new URL(more.href, window.location.origin);
        url.searchParams.set('section_id', section.dataset.section);
        const html = await fetch(url.toString()).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-k-grid] > .k-grid__item').forEach((li) => grid.appendChild(li));
        const nextWrap = doc.querySelector('.k-grid__more');
        const wrap = section.querySelector('.k-grid__more');
        if (nextWrap && wrap) wrap.replaceWith(nextWrap);
        else if (wrap) wrap.remove();
      } catch (err) {
        console.error(err);
        window.location.href = more.href;
      }
    });
  }

  const boot = () => document.querySelectorAll('.k-collection').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
